import shared from 'emun.order/_required.es6';

export default Object.assign(shared, {
  email: true,
  buyer: true,
  cancelOn: true

});
